export const STICKERS_URL = "/jiffystickers-STKR-DC001.html?ac=Sticker";
// Hardcoded die cut sticker product and variant id to avoid extra API call to get this data.
export const DIE_CUT_PRODUCT_ID = "481462";
export const DIE_CUT_VARIANT_ID = "1695700";
export const CART_URL = "/cart";
export const SUCCESS_DELAY = 2000;
export const CUSTOM_VALUE = "custom";
export const WIDTHS = [2, 3, 4];
export const MIN_QUANTITY = 10;
